<template>
  <div class="add-variant">
    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('products.modals.addVariant.title') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="form.valid">
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="form.data.description"
                  :label="$t('products.modals.addVariant.description')"
                  type="textarea"
                  hide-details
                  dense
                  rounded
                  outlined
                  no-resize
                />
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col cols="12">
                <p class="subtitle-1">
                  {{ $t('products.modals.addVariant.infoSubtitle')}}
                </p>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  data-cy="brand"
                  v-model="form.data.brand"
                  :label="$t('products.modals.addVariant.brand')"
                  type="text"
                  hide-details
                  dense
                  rounded
                  outlined>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.data.satCode"
                  required
                  rounded
                  outlined
                  dense
                  hide-details
                  maxlength="8"
                  :rules="form.rules.satCode"
                  :label="$t('products.labels.satCode')"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.data.amountInvoice"
                  :label="$t('products.modals.addVariant.cost')"
                  :rules="form.rules.required"
                  prefix="$"
                  type="number"
                  hide-details
                  dense
                  rounded
                  outlined
                  @blur="updateCost"
                  >
                </v-text-field>
              </v-col><v-col cols="6">
                <v-text-field
                  v-model="form.data.profit"
                  dense
                  rounded
                  outlined
                  hide-details
                  prefix="%"
                  label="Porcentaje de ganancia"
                  @blur="updateAmount">
                  <template v-slot:append>
                    <v-tooltip
                      max-width="200"
                      left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          color="primary"
                          icon
                          x-small
                          depressed
                        >
                          <v-icon>mdi-help</v-icon>
                        </v-btn>
                      </template>
                      <span>
                        Si la factura es de un proveedor tuyo, le aumentas un porcentaje para tener una ganancia del precio que te vende tu proveedor.
                      </span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  data-cy="amount"
                  v-model="form.data.amount"
                  :disabled="!form.data.amountInvoice"
                  :label="$t('products.modals.addVariant.price')"
                  :rules="form.rules.required"
                  prefix="$"
                  type="number"
                  hide-details
                  dense
                  rounded
                  outlined
                  @blur="updateProfit">
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.data.amountWithTaxes"
                  :disabled="!form.data.amountInvoice"
                  :loading="loader"
                  :label="$t('products.modals.addVariant.priceWithTaxes')"
                  prefix="$"
                  type="number"
                  hide-details
                  dense
                  rounded
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="tax"
                  dense
                  :items="searchTaxes.items"
                  @change="addTax($event)"
                  loading="Cargando impuestos"
                  :search-input.sync="searchTaxes.search"
                  return-object
                  outlined
                  rounded
                  color="primary"
                  hide-details
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="_id"
                  label="Impuestos"
                  placeholder="Nombre del impuesto"
                />
              </v-col>
              <v-col cols="6" />
              <v-col cols="6">
                <draggable v-model="form.data.taxes" group="taxes" @start="drag=true" @end="drag=false" v-if="form.data.taxes" :move="calculateAmountWithTaxes">
                  <div v-for="(element, index) in form.data.taxes" :key="element._id">
                    <div class="item">
                       <v-icon
                          small
                          color="primary"
                          class="mr-1"
                          >
                            mdi-drag
                          </v-icon>
                      <span class="mr-1">{{element.name}}</span>
                      <v-tooltip right>
                        <template>
                          <v-icon
                            small
                            color="error"
                            style="float: right"
                            @click="removeItem(index)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                          <span>Eliminar elemento</span>
                      </v-tooltip>
                    </div>
                  </div>
                </draggable>
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col cols="12">
                <p class="subtitle-1">
                  {{ $t('products.modals.addVariant.warehouseSubtitle')}}
                </p>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  data-cy="displayUnit"
                  v-model="form.data.displayUnit"
                  :label="$t('products.modals.addVariant.displayUnit')"
                  :rules="form.rules.required"
                  :items="units"
                  :filter="filterUnit"
                  item-text="name"
                  item-value="id"
                  hide-details
                  dense
                  rounded
                  outlined>
                  <template v-slot:append>
                    <v-tooltip
                      max-width="250"
                      open-delay="500"
                      close-delay="2000"
                      color="primary"
                      top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          color="primary"
                          x-small
                          depressed
                        >
                          <v-icon
                            small
                          >
                            mdi-help
                          </v-icon>
                        </v-btn>
                      </template>
                      <div>
                        La unidad de presentación debe ser una unidad válida por el SAT, esta unidad es con la que será facturada tu producto.<br>
                        Mas información aquí:<br>
                        <a class="primary-text" href="http://pys.sat.gob.mx/PyS/catUnidades.aspx" target="_blank" rel="noopener noreferrer">Catálogo de Unidades del SAT</a>
                      </div>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6" />
              <v-col cols="6">
                <v-text-field
                  data-cy="contentQuantity"
                  v-model="form.data.contentQuantity"
                  :label="$t('products.modals.addVariant.contentQuantity')"
                  :rules="form.rules.required"
                  type="number"
                  hide-details
                  dense
                  rounded
                  outlined>
                  <template v-slot:append>
                    <v-tooltip
                      max-width="250"
                      top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          color="primary"
                          x-small
                          depressed
                        >
                          <v-icon
                            small
                          >
                            mdi-help
                          </v-icon>
                        </v-btn>
                      </template>
                      <div>
                        La cantidad de contenido es cuanto tiene esa presentación que vendes, por ejemplo si es 1 Caja, pero contiene 10 paquetes.
                      </div>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  data-cy="contentUnit"
                  v-model="form.data.contentUnit"
                  :label="$t('products.modals.addVariant.contentUnit')"
                  :rules="form.rules.required"
                  :items="units"
                  :filter="filterUnit"
                  item-text="name"
                  item-value="id"
                  hide-details
                  dense
                  rounded
                  outlined>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="close">
            {{ $t('products.modals.addVariant.cancel') }}
          </v-btn>
          <v-btn
            data-cy="addVariant-succes"
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            @click="submit">
            {{ $t('products.modals.addVariant.success') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import draggable from 'vuedraggable'
export default {
  components: {
    draggable
  },
  data () {
    return {
      isOpen: false,
      overlay: false,
      form: {
        valid: false,
        loading: false,
        data: {
          description: '',
          amountInvoice: 0,
          profit: 0,
          amount: 0,
          brand: '',
          displayUnit: '',
          contentQuantity: 0,
          contentUnit: '',
          yield: 100,
          satCode: '',
          amountWithTaxes: 0,
          taxes: []
        },
        rules: {
          required: [v => !!v || this.$t('validations.required')],
          satCode: [
            v => !!v || this.$t('validations.satCode.required'),
            v => /^[0-9a-zA-Z]+$/.test(v) || this.$t('validations.satCode.valid'),
            v => v.length === 8 || 'El satCode debe de ser de 8 carácteres'
          ]
        }
      },
      tax: '',
      loader: false,
      searchTaxes: {
        search: '',
        selected: null,
        items: [],
        isLoading: false
      }
    }
  },
  watch: {
    'searchTaxes.search': debounce(async function (val) {
      if (val && val.length >= 3) {
        this.searchTaxes.isLoading = true
        const params = { name: `/${val}/i` }
        try {
          const res = await this.$api.get(`/v1/providers/${this.$store.state.currentProvider.data._id}/taxes`, params)
          this.searchTaxes.items = res.data
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.searchTaxes.isLoading = false
      }
    }, 600)
  },
  computed: {
    units () {
      return this.$store.state.login.units.data
    }
  },
  methods: {
    open () {
      this.isOpen = true
    },
    close () {
      this.reset()
      this.isOpen = false
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.$emit('add', this.form.data)
        this.close()
      }
    },
    reset () {
      this.form.data = {
        description: '',
        amount: 0,
        amountInvoice: 0,
        profit: 0,
        brand: '',
        displayQuantity: '',
        displayUnit: '',
        contentQuantity: 0,
        contentUnit: '',
        yield: 100,
        satCode: '',
        amountWithTaxes: 0,
        taxes: []
      }
      this.tax = ''
      this.loader = false
      this.$refs.form.resetValidation()
    },
    filterUnit (item, queryText, itemText) {
      const a = new RegExp(queryText, 'gi')
      if (a.test(itemText)) {
        return item
      }
    },
    calculateAmount (amount, profit) {
      const rate = (profit || 0) / 100
      const price = amount + (amount * rate)
      return Number(price).toFixed(2)
    },
    updateAmount (event) {
      const amount = this.calculateAmount(Number(this.form.data.amountInvoice), Number(event.target.value))
      this.form.data.amount = amount
      this.calculateAmountWithTaxes()
    },
    calculatePercentage (price, amount) {
      const profit = price - amount
      const percentage = (profit * 100) / amount
      return Number(percentage).toFixed(2)
    },
    updateProfit (event) {
      const profit = this.calculatePercentage(Number(event.target.value), Number(this.form.data.amountInvoice))
      this.form.data.profit = profit
      this.calculateAmountWithTaxes()
    },
    calculateCost (amount, profit) {
      const rate = (profit || 0) / 100
      const price = amount + (amount * rate)
      return Number(price).toFixed(2)
    },
    updateCost (event) {
      const amount = this.calculateCost(Number(event.target.value), this.form.data.profit)
      this.form.data.amount = amount
    },
    addTax (tax) {
      if (tax) {
        this.form.data.taxes.push(tax)
        this.calculateAmountWithTaxes()
        this.$nextTick(() => {
          this.tax = ''
        })
      }
    },
    removeItem (item) {
      this.form.data.taxes.splice(item, 1)
      this.calculateAmountWithTaxes()
    },
    async calculateAmountWithTaxes () {
      this.loader = true
      try {
        const response = await this.$api.post(`/v1/catalog/1/taxes/total`, { amount: this.form.data.amount, taxes: this.form.data.taxes })
        this.form.data.amountWithTaxes = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  margin: 1px;
  padding: 10px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
  background: #f4f3f3;
  display: inline-block;
  width: 100%;
}
</style>
